import classNames from 'classnames';
import React from 'react';

import type { Node } from './../../ricos-schema/legacy/wix/rich_content/v1/index.js';
import { Decoration_Type } from './../../ricos-schema/legacy/wix/rich_content/v1/index.js';
import type { AnchorDecoration, NodeViewDecorator } from './../../ricos-types/index.js';
import { addAnchorTagToUrl, anchorScroll } from './../../wix-rich-content-common/index.js';

import { ANCHOR_LINK } from '../data-hooks.js';
import styles from '../statics/link-viewer-scss.js';

const decorator = (anchorDecoration: AnchorDecoration, element?: JSX.Element) => {
  const { anchor } = anchorDecoration.anchorData;
  return (
    <a
      key={`anchor-${element?.key}`}
      target="_self"
      href={`#viewer-${anchor}`}
      className={classNames(styles.link, styles.linkInViewer)}
      onClick={e => {
        e.stopPropagation(); // fix problem with wix platform, where it wouldn't scroll and sometimes jump to different page
        e.preventDefault();

        const anchorString = `viewer-${anchor}`;
        const element = document.getElementById(anchorString);
        addAnchorTagToUrl(anchorString);
        element && anchorScroll(element);
      }}
      data-hook={ANCHOR_LINK}
    >
      {element}
    </a>
  );
};

const AnchorDecorator: NodeViewDecorator<JSX.Element> = {
  rule: (node: Node) =>
    !!node.textData?.decorations?.some(({ type }) => type === Decoration_Type.ANCHOR),
  decorate: ({ element, node }) => {
    const anchorDecoration = node.textData?.decorations?.find(
      ({ type }) => type === Decoration_Type.ANCHOR
    ) as AnchorDecoration;
    return decorator(anchorDecoration, element);
  },
  priority: 1000,
};

export default AnchorDecorator;
